import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const FilterIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 20 18" {...props}>
    <path
      id="Tracé_12110"
      data-name="Tracé 12110"
      d="M28.565,20.32H26.974a2.361,2.361,0,0,0-4.643,0H9.435a.435.435,0,1,0,0,.87h12.9a2.361,2.361,0,0,0,4.643,0h1.591a.435.435,0,1,0,0-.87Zm-3.913,1.93a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,24.652,22.25ZM28.565,26.6H21.322a2.361,2.361,0,0,0-4.643,0H9.435a.435.435,0,1,0,0,.87h7.243a2.361,2.361,0,0,0,4.643,0h7.243a.435.435,0,1,0,0-.87ZM19,28.533a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,19,28.533ZM9.435,14.907h1.591a2.361,2.361,0,0,0,4.643,0h12.9a.435.435,0,0,0,0-.87H15.67a2.361,2.361,0,0,0-4.643,0H9.435a.435.435,0,0,0,0,.87Zm3.913-1.93a1.5,1.5,0,1,1-1.5,1.5A1.5,1.5,0,0,1,13.348,12.976Z"
      transform="translate(-9 -11.9)"
    />
  </SvgIcon>
));

export default React.memo(FilterIcon);
